<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="main-row">
  <div class="col-md-12">
    <fieldset *ngIf="isWorldPay()">
      <legend class="row">
        <div class="col-md-6 m-auto">Fraud / Risk Variables</div>
        <div class="col-md-6">
          <button
            class="btn btn-primary float-right"
            *ngIf="
              merchant.fraudVars &&
              hasFinanceRole() &&
              isMerchantActive() &&
              !editable
            "
            (click)="setEditable(true)"
          >
            <span>
              <fa-icon [icon]="faEditPencil"></fa-icon>
            </span>
            Edit Fraud / Risk Variables
          </button>
        </div>
      </legend>

      <div class="row mt-3" *ngIf="merchant.fraudVars && !editable">
        <div class="col-md-6">
          <div class="table-block">
            <div class="recordRow">
              <div class="recordLabel">Duplicate Dollar Transaction Count</div>
              <div id="ddtCount" class="recordValue">
                {{ merchant.fraudVars.duplicateDollarTxCount }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">Duplicate Dollar Transaction Amount</div>
              <div id="ddtAmount" class="recordValue">
                {{ merchant.fraudVars.duplicateDollarTxAmount }}
              </div>
            </div>

            <div class="recordRow">
              <div class="recordLabel">Daily Unmatched Credits Count</div>
              <div id="ducCount" class="recordValue">
                {{ merchant.fraudVars.dailyUnmatchedCreditsCount }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">Daily Unmatched Credits Amount</div>
              <div id="ducAmount" class="recordValue">
                {{ merchant.fraudVars.dailyUnmatchedCreditsAmount }}
              </div>
            </div>

            <div class="recordRow">
              <div class="recordLabel">Same Card Transaction Count</div>
              <div id="sctCount" class="recordValue">
                {{ merchant.fraudVars.sameCardTxCount }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">Same Card Transaction Amount</div>
              <div id="sctAmount" class="recordValue">
                {{ merchant.fraudVars.sameCardTxAmount }}
              </div>
            </div>

            <div class="recordRow">
              <div class="recordLabel">Total Daily Foreign Card Count</div>
              <div id="tdfcCount" class="recordValue">
                {{ merchant.fraudVars.totalDailyForeignCardCount }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">Total Daily Foreign Card Amount</div>
              <div id="tdfcAmount" class="recordValue">
                {{ merchant.fraudVars.totalDailyForeignCardTxAmount }}
              </div>
            </div>

            <div class="recordRow">
              <div class="recordLabel">Transaction Limit to Alert</div>
              <div id="transactionLimitToAlert" class="recordValue">
                {{ merchant.fraudVars.txLimitToAlert | currency }}
              </div>
            </div>

            <div class="recordRow">
              <div class="recordLabel">Single Forced Transaction Amount</div>
              <div id="singleForcedTransactionLimit" class="recordValue">
                {{ merchant.fraudVars.singleForcedTxAmount }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">Aggregate Forced Transaction Amount</div>
              <div id="aggregateForcedTransactionLimit" class="recordValue">
                {{ merchant.fraudVars.aggregateForcedTxAmount }}
              </div>
            </div>

            <div class="recordRow">
              <div class="recordLabel">Stale Transaction Days</div>
              <div id="staleDays" class="recordValue">
                {{ merchant.fraudVars.staleTxDays }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="table-block">
            <div class="recordRow">
              <div class="recordLabel">
                Excessive Volume Increase % - Daily vs. 90 Day
              </div>
              <div id="evvDailyVs90DaysPercent" class="recordValue">
                {{ merchant.fraudVars.excessiveVolumeIncreasePercent1vs90 }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">
                Excessive Volume Increase Amount - Daily vs. 90 Day
              </div>
              <div id="evvDailyVs90DaysAmount" class="recordValue">
                {{ merchant.fraudVars.excessiveVolumeIncreaseAmount1vs90 }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">
                Excessive Volume Increase % - Daily vs. 30 Day
              </div>
              <div id="evvDailyVs30DaysPercent" class="recordValue">
                {{ merchant.fraudVars.excessiveVolumeIncreasePercent1vs30 }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">
                Excessive Volume Increase Amount - Daily vs. 30 Day
              </div>
              <div id="evvDailyVs30DaysAmount" class="recordValue">
                {{ merchant.fraudVars.excessiveVolumeIncreaseAmount1vs30 }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">
                Excessive Volume Increase % - Daily vs. 7 Day
              </div>
              <div id="evvDailyVs7DaysPercent" class="recordValue">
                {{ merchant.fraudVars.excessiveVolumeIncreasePercent1vs7 }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">
                Excessive Volume Increase Amount - Daily vs. 7 Day
              </div>
              <div id="evvDailyVs7DaysAmount" class="recordValue">
                {{ merchant.fraudVars.excessiveVolumeIncreaseAmount1vs7 }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">
                Excessive Volume Increase % - 7 Day vs. 90 Day
              </div>
              <div id="evv7DayVs90DaysPercent" class="recordValue">
                {{ merchant.fraudVars.excessiveVolumeIncreasePercent7vs90 }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">
                Excessive Volume Increase Amount - 7 Day vs. 90 Day
              </div>
              <div id="evv7DayVs90DaysAmount" class="recordValue">
                {{ merchant.fraudVars.excessiveVolumeIncreaseAmount7vs90 }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3" *ngIf="editable">
        <form
          name="fraudRiskFormControl"
          class="form-horizontal"
          novalidate
          [formGroup]="fraudRiskForm"
          (submit)="updateFraudRisk()"
        >
          <app-fraud-and-risk-edit
            [merchant]="merchant"
            [parentGroup]="fraudRiskForm"
          ></app-fraud-and-risk-edit>
          <app-edit-buttons
            [buttonName]="buttonName"
            [actionInProgress]="actionInProgress"
            [formInvalid]="fraudRiskForm.invalid"
            (editableEvent)="setEditable(false)"
          >
          </app-edit-buttons>
        </form>
      </div>
    </fieldset>
  </div>
</div>
